import Footer from '../components/Footer';
import Contact from '../components/Contact';
import Header from '../components/Header';
import SeoHelmet from '../components/SeoHelmet';
import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const About = () => {
  const { currentLanguage, t } = useLanguage();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadContent();
  }, [currentLanguage]);

  const loadContent = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/pages/about?language=${currentLanguage}`);
      const pageData = response.data;
      setContent(pageData.content);
    } catch (error) {
      console.error('Error loading about page:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-xl text-gray-600">{t('loading') || 'Загрузка...'}</div>
      </div>
        <Contact />
      <Footer />
    </>
  );
  }

  if (!content) {
    return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-xl text-gray-600">
          {currentLanguage === 'RU' ? 'Контент не найден' : 'Content not found'}
        </div>
      </div>
        <Contact />
      <Footer />
    </>
  );
  }

  return (
    <>
      <SeoHelmet
        title={currentLanguage === 'EN' ? 'About VELOX HINT — Customs & Foreign Trade Experts' : 'О компании ВЕЛОКС ХИНТ — эксперты ВЭД и таможни'}
        description={currentLanguage === 'EN' ? 'Professional consulting on Russian customs, certification and licensing. 15+ years on the market.' : 'Профессиональные консультации по таможне, сертификации и лицензированию в России. 15+ лет на рынке.'}
      />
      <Header />
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="container mx-auto px-4 max-w-7xl">
        {/* Hero Section */}
        <div className="mb-16 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {content.hero?.title || 'О компании ВЕЛОКС ХИНТ'}
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {content.hero?.subtitle || 'Профессиональные консультации'}
          </p>
        </div>

        {/* History Section */}
        {content.history && (
          <div className="mb-16">
            <div className="bg-white rounded-lg shadow-sm p-8 md:p-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                {content.history.title}
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                {content.history.content}
              </p>
            </div>
          </div>
        )}

        {/* Values Section */}
        {content.values && (
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              {content.values.title}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {content.values.items?.map((value, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg shadow-sm p-6 hover:shadow-md transition"
                >
                  <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                    <span className="text-2xl font-bold text-orange-500">{index + 1}</span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h3>
                  <p className="text-gray-600">{value.description}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Partners Section */}
        {/*
	{content.partners && (
          <div className="bg-gradient-to-br from-orange-50 to-white rounded-lg shadow-sm p-8 md:p-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">
              {content.partners.title}
            </h2>
            <p className="text-lg text-gray-600 mb-8 text-center max-w-3xl mx-auto">
              {content.partners.content}
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto">
              {content.partners.items?.map((partner, index) => (
                <div
                  key={index}
                  className="flex items-center bg-white rounded-lg p-4 shadow-sm"
                >
                  <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span className="text-gray-700">{partner}</span>
                </div>
              ))}
            </div>
          </div>
        )}
        */}
      </div>
    </div>
      <Contact />
      <Footer />
    </>
  );
};

export default About;
